<div class="p-fluid space-y-3" [formGroup]="formGroup">
    <div class="flex flex-col gap-1">
        <label for="country-code">Country <span class="text-red-500">*</span></label>
        <p-select
            inputId="country-code"
            [filter]="true"
            [options]="countries"
            optionLabel="name"
            optionValue="code"
            appendTo="body"
            formControlName="countryCode"
            placeholder="Select country"
            class="w-full"
            [ngClass]="{
                'ng-dirty': submitted && formGroup.get('countryCode')?.invalid,
                'ng-invalid': submitted && formGroup.get('countryCode')?.invalid
            }"
        />
        <small *ngIf="submitted && formGroup.get('countryCode')?.hasError('required')" class="text-red-500">Country is required.</small>
    </div>

    <div class="flex flex-col gap-1">
        <label for="port">Port <span class="text-red-500">*</span></label>
        <p-select
            inputId="port"
            [filter]="true"
            [options]="filteredPorts"
            optionLabel="explanation"
            optionValue="code"
            appendTo="body"
            formControlName="port"
            placeholder="Select port"
            class="w-full"
            [disabled]="!formGroup.get('countryCode')?.value || loadingPorts"
            [ngClass]="{
                'ng-dirty': submitted && formGroup.get('port')?.invalid,
                'ng-invalid': submitted && formGroup.get('port')?.invalid
            }"
        />
        <small *ngIf="loadingPorts" class="text-gray-500">Loading data...</small>
        <small *ngIf="submitted && formGroup.get('port')?.hasError('required')" class="text-red-500">Port is required.</small>
    </div>

    <div class="flex flex-col gap-1">
        <label for="providers">Providers</label>
        <p-multiselect
            inputId="providers"
            [options]="providers"
            optionLabel="explanation"
            optionValue="id"
            appendTo="body"
            formControlName="providerIds"
            placeholder="Select providers (optional - applies to all if empty)"
            class="w-full"
            display="chip"
        />
        <small class="text-gray-500">Leave empty to apply to all providers</small>
    </div>

    <div class="flex flex-col gap-1">
        <label for="provider-supplier">Provider Supplier</label>
        <input
            id="provider-supplier"
            pInputText
            formControlName="providerSupplier"
            placeholder="Provider supplier"
            class="w-full p-inputtext"
            maxlength="255"
        />
    </div>

    <div class="flex flex-col gap-2">
        <label>Status</label>
        <div class="flex items-center gap-2 pl-1">
            <p-toggleswitch formControlName="active" inputId="activeToggle"></p-toggleswitch>
            <label for="activeToggle">{{ formGroup.get('active')?.value ? 'Active' : 'Inactive' }}</label>
        </div>
    </div>

    <div class="flex justify-between pt-4">
        <p-button label="Cancel" [text]="true" severity="secondary" (click)="onCancel()"></p-button>
        <p-button [label]="mode === 'add' ? 'Add New' : 'Save'" (click)="onSave()"></p-button>
    </div>
</div>
